<div class="actions-history-table">
  <p class="p1">
    {{ 'History: ' | trans:'cards/card-details-modal/actions/history.Label' }}
  </p>

  <table class="base-2 m-t-16">
    <thead>
    <tr>
      <th>
        {{ 'Type & Status' | trans:'cards/card-details-modal/actions/type-series.Label' }}
      </th>
      <th class="text-right">
        {{ 'Details' | trans:'cards/card-details-modal/actions/details.Label' }}
      </th>
    </tr>
    </thead>
    <tbody>
      @for (action of (cardActionsHistory | slice:0:actionHistorySliceEnd); track action.cardActionId) {
        <tr>
          <td>
            <p class="p2 c-t-blue-700">
              {{ action.actionTypeKey | trans:'cards/card-details-modal/actions/actionTypeKey.' + action.actionTypeKey }}
            </p>
            <div class="tag card-status--{{ action.statusKey }}">
              {{ action.statusKey | trans:'cards/card-details-modal/actions/statusKey.' + action.statusKey }}
            </div>
          </td>
          <td class="text-right">
            <p class="p2">
              {{ action.actionDate | localeDatetimeFormat }}
            </p>
            <p class="m-t-8 p2">
              {{ action.actionEmployeeName }}
            </p>
          </td>
        </tr>
      }
    </tbody>
  </table>

  @if (actionHistorySliceEnd < cardActionsHistory.length) {
    <button
      class="t1 fw-medium c-t-blue-700 full-width button button--lg button--secondary"
      (click)="actionHistorySliceEnd = actionHistorySliceEnd + 5"
    >
      {{ 'Show more' | trans:'cards/card-details-modal/actions/show-more-button.Label' }}
    </button>
  }
</div>
